import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import CardThirdPartyServices, {buttonTypes} from '@adv-mt/mt-card-third-party-services'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import CardCarfaxModalContent from './carfax-modal-content.js'
import CardCarfaxServiceContent from './carfax-service-content.js'
import {BASE_CLASS} from './config.js'

const BUTTON_COLOR = 'success'

const PANEL_TYPES = {
  BASIC_PANEL: 'BASIC_PANEL',
  VERIFIED_DATA_PANEL: 'VERIFIED_DATA_PANEL'
}

const CardCarfax = ({adId, adTitle, vehicleHistory}) => {
  const {domain, i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const providerLogoSrc = `${URL_STATICS_IMAGES}common/logos/carfax-logo-white-box.svg`

  const {hasReport, reportUrl, verifiedData} = vehicleHistory

  const panelType = hasReport ? PANEL_TYPES.VERIFIED_DATA_PANEL : PANEL_TYPES.BASIC_PANEL

  const sharedInfo = {
    title: i18n.t('CARFAX.TITLE'),
    text: htmlStringToReactElement(
      i18n.t(`CARFAX.SUBTITLE.${panelType}`, {
        strongStart: `<span className="${BASE_CLASS}--highlighted">`,
        strongEnd: '</span>'
      })
    ),
    buttonColor: BUTTON_COLOR,
    buttonText: i18n.t(`CARFAX.BUTTON.${panelType}.TEXT`),
    buttonType: hasReport ? buttonTypes.button : buttonTypes.link
  }

  const getBasicPanelInfo = () => ({
    bottomText: i18n.t('CARFAX.BUTTON.BASIC_PANEL.DESCRIPTION'),
    buttonHref: reportUrl,
    image: providerLogoSrc
  })

  const getVerifiedDataPanelInfo = () => ({
    customContent: <CardCarfaxServiceContent adTitle={adTitle} verifiedData={verifiedData.value} />,
    image: providerLogoSrc,
    imageText: i18n.t('CARFAX.BUTTON.VERIFIED_DATA_PANEL.DESCRIPTION')
  })

  const thirdPartyInfo = {
    ...sharedInfo,
    ...(hasReport ? {...getVerifiedDataPanelInfo()} : {...getBasicPanelInfo()})
  }

  const modalContent = hasReport && <CardCarfaxModalContent urlIframeContent={reportUrl} />

  const getAdvertisementsTracking = () =>
    domain.get('get_advertisements_tracking_use_case').execute({
      ads: [adId],
      context: 'other'
    })

  const handleToggleModal = ({isOpen}) =>
    isOpen &&
    getAdvertisementsTracking().then(({products}) => track({event: 'Free Vehicle History Clicked', data: {products}}))

  const handleClickLink = () =>
    getAdvertisementsTracking().then(({products}) => track({event: 'Vehicle History Clicked', data: {products}}))

  return (
    <div className={BASE_CLASS}>
      <CardThirdPartyServices
        children={modalContent}
        modalCallback={handleToggleModal}
        onClickLink={handleClickLink}
        thirdPartyInfo={thirdPartyInfo}
      />
    </div>
  )
}

CardCarfax.displayName = 'CardCarfax'
CardCarfax.propTypes = {
  adId: PropTypes.string,
  adTitle: PropTypes.string,
  vehicleHistory: PropTypes.shape({
    hasReport: PropTypes.bool,
    reportUrl: PropTypes.string,
    verifiedData: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.shape({text: PropTypes.string, value: PropTypes.string}))
    })
  })
}
export default CardCarfax
